import { Component, OnInit, ViewChild } from '@angular/core';
import { ServiciosService } from "../servicios/servicios.service";
import { ListasReporte } from "../entidades/listas-reporte";
import { ListasTerceros } from "../entidades/listas-terceros";
import { Usuario } from "../entidades/usuario";
import { Terceros } from "../entidades/terceros";
import { FormControl, Validators, FormGroup, FormBuilder } from "@angular/forms";
import { startWith, map, count } from "rxjs/operators";
import { ChangeDetectorRef } from '@angular/core/';
import {MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS} from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';

import { Globals } from "../../globals";

import { 
  ChartComponent,
  ApexNonAxisChartSeries,
  ApexResponsive,
  ApexChart,
  ApexAxisChartSeries,
  ApexDataLabels,
  ApexPlotOptions,
  ApexYAxis,
  ApexLegend,
  ApexStroke,
  ApexXAxis,
  ApexFill,
  ApexTooltip,
  ApexTitleSubtitle
} from "ng-apexcharts";

import { Observable } from "rxjs";

import * as moment from 'moment';

import Swal from "sweetalert2";

export var single = [
  {
    "name": "Usuarios",
    "value": 894
  },
];

export interface FuncionariosElement {
  nombre_completo: string;
  tipo_conflicto_espanol: string;
  annio: string;
  fecha_registro: string;
  detalle: string;
  estado_conflicto: string;
  estado: string;
}

export type ChartOptions = {
  series: ApexNonAxisChartSeries;
  chart: ApexChart;
  colors: string[];
  fill: ApexFill;
  responsive: ApexResponsive[];
  labels: any;
};

export type ChartOptionsBar = {
  series: ApexAxisChartSeries;
  chart: ApexChart;
  dataLabels: ApexDataLabels;
  plotOptions: ApexPlotOptions;
  yaxis: ApexYAxis;
  xaxis: ApexXAxis;
  fill: ApexFill;
  tooltip: ApexTooltip;
  stroke: ApexStroke;
  legend: ApexLegend;
};

const date = moment();

export const MY_FORMATS = {
  parse: {
    dateInput: 'DD/MM/YYYY',
  },
  display: {
    dateInput: 'DD/MM/YYYY',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@Component({
  selector: 'app-reporte-estadistico',
  templateUrl: './reporte-estadistico.component.html',
  styleUrls: ['./reporte-estadistico.component.css'],
  providers: [
    // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
    // application's root module. We provide it at the component level here, due to limitations of
    // our example generation script.
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    {provide: MAT_DATE_FORMATS, useValue: MY_FORMATS},
  ],
})
export class ReporteEstadisticoComponent implements OnInit {
  dataSource = new MatTableDataSource<FuncionariosElement>([]);
  is_year: boolean = true;
  loading: boolean = true;
  identity_tab: number = 0;
  month: any[] = [
    "Ene",
    "Feb",
    "Mar",
    "Abr",
    "May",
    "Jun",
    "Jul",
    "Agos",
    "Sep",
    "Oct",
    "Nov",
    "Dic"
  ];

  annio:any[]

  displayedColumns: string[] = ["nombre_completo", "tipo_conflicto_espanol", "annio", "fecha_registro","detalle","estado_conflicto","estado"];
  headerHojaVida = ["Nombre Empleado", "Tipo Conflicto", "Año", "Fecha registro", "Detalle", "Estado", "Vigencia"];
  bodyHojaVida = null;

  anio_actual = new Date().getFullYear();
  listaAnnios=[];
  single: any[];
  view: any[] = [200, 200];
  lista_preguntas: any[] = [];
  lista_funcionarios: any[] = [];
  lista_proveedores_all: any[] = [];
  lista_preguntas_all: any[] = [];
  lista_funcionarios_all: any[] = [];

  colorScheme = {
    domain: ['#a8385d', '#E44D25', '#CFC0BB']
  };
  cardColor: string = 'white';

  usuario: Usuario = new Usuario();
  terceros: Terceros = new Terceros();

  view_form: number = 1;

  view_form_respuestas=false;

  tarjeta1Conflictos=0;
  tarjeta2Conflictos=0;
  tarjeta3Conflictos=0;
  tarjeta4Conflictos=0;
  tarjeta5Conflictos=0;

  listasReporte: ListasReporte = new ListasReporte();
  listasTerceros: ListasTerceros = new ListasTerceros();
  listasReporteRespuesta: ListasReporte = new ListasReporte();
  
  // AUTOCMPLETE FORM 2 DATA
  list_terceros: Observable<string[]>;
  list_usuarios: Observable<string[]>;
  list_conflictos: Observable<string[]>;

  list_terceros_all: Observable<string[]>;
  list_usuarios_all: Observable<string[]>;
  list_conflictos_all: Observable<string[]>;

  terceros_options: string[] = [];
  usuarios_options: string[] = [];
  conflictos_options: string[] = [];

  // AUTOCMPLETE FORM DATA
  list_vicepresidencias: Observable<string[]>;
  list_paises: Observable<string[]>;
  list_gerencia: Observable<string[]>;
  list_area: Observable<string[]>;
  list_lugar: Observable<string[]>;
  list_tipo_conflicto: Observable<string[]>;
  tipo_conflictos_all = [];
  tipo_respuestas_all = [];
  
  // INFORMATION CARDS OF REPORT INQUEST
  cantidad_usuarios: number = 0;
  cantidad_usuarios_total: number = 0;
  respuesta_funcionarios: number = 0;
  cantidad_respuesta_funcionarios_total: number = 0;
  respuesta_funcionarios_porcentaje: number = 0;
  conflictos_activos: number = 0;
  cantidad_conflictos_funcionarios_total: number = 0;

  // INFORMATION CARDS OF REPORT ADMINISTRADOR CONFLICTS
  cantidad_riesgo_identificado: number = 0;
  cantidad_no_riesgo: number = 0;
  cantidad_elevados_compliance: number = 0;
  cantidad_atendidos_compliance: number = 0;
  cantidad_registrados_compliance: number = 0;
  total_administrados: number = 0;
  total_pendientes: number = 0;

  // INFORMATION CARDS OF INQUEST
  cantidad_reportados: number = 0;
  cantidad_nuevos: number = 0;
  permanecen_igual: number = 0;
  marcaron_cambios: number = 0;
  no_existen: number = 0;
  show_button_terceros: boolean = false;
  show_button_funcionarios: boolean = false;
  show_button_conflictos: boolean = false;

  // CONTROLS AUTOCOMPLETES FORM
  formularioRegistro: FormGroup;
  controlPais = new FormControl("", [Validators.required]);
  controlGerencia = new FormControl("", [Validators.required]);
  controlVicepresidencia = new FormControl("", [Validators.required]);
  controlArea = new FormControl("", [Validators.required]);
  controlLugar = new FormControl("", [Validators.required]);
  controlTipoConflicto = new FormControl("", [Validators.required]);

  formularioTerceros: FormGroup;
  controlTerceros = new FormControl("", [Validators.required]);
  controlUsuarios = new FormControl("", [Validators.required]);
  controlConflicto = new FormControl("", [Validators.required]);
  
  annio_actualy: any = moment().format('YYYY');
  month_actualy: any = moment().format('MM');
  day_actualy: any = moment().format('DD');

  minDate = new Date(this.annio_actualy, 0, 1); //minDate is 1st Jan 2019
  maxDate = new Date((this.annio_actualy + 1), 0, 1); //maxDate is 1st Jan 2020
  
  fechaIni = new FormControl(moment().subtract(1, 'years').format('DD/MM/YYYY'), [Validators.required]);
  fechaFin = new FormControl(moment().format('DD/MM/YYYY'), [Validators.required]);

  ver: boolean = false;
  ver_todo: boolean = false;
  idioma: string = 'Es';
  verConflicto: any = [];
  headerTable: any = [];
  bodyTable: any = [];
  headerAdicional: any = [];
  bodyAdicional: any = [];
  verRespuestaConfilcto: any = [];
  comentariosJefe: any = true;
  comentariosCompliance: any = true;
  nombre_funcionario: any = false;
  pregunta: any = false;
  identificadorActual: any = false;
  comentariosAntiguos: any = [];
  validarComentariosAntiguos: any = false;
  selected_row: any = false;

  respuestasCorrectas=[]
  respuestasIncorrectas=[]
  infoConflicto;
  ver_respuesta: boolean = false

  @ViewChild("chartBar", {static: false}) chartBar: ChartComponent;
  @ViewChild("chart", {static: false}) chart: ChartComponent;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;
  /* @ViewChild(MatPaginator, {static: false})
  set paginator(value: MatPaginator) {
    this.dataSource.paginator = value;
  } */
  @ViewChild('paginatorRespuesta', {static: false}) set paginatorRespuesta(value: MatPaginator) {
    this.dataSourceRespuesta.paginator = value;
  }
  @ViewChild('paginator2', {static: false}) set paginator2(value: MatPaginator) {
    this.dataSource2.paginator = value;
  }

  displayedColumnsRespuestas: string[] = ["nombre_completo","correo_corporativo",'area','fecha_registro'];
  displayedColumns2: string[] = ["nombre_completo","correo_corporativo",'area','fecha_registro'];

  public chartOptionsBar: Partial<ChartOptionsBar>;
  public chartOptionsBarAdmin: Partial<ChartOptionsBar>;
  public pieChartRespuestas:  Partial<ChartOptions>;
  public pieChartNuevosPasados:  Partial<ChartOptions>;
  public chartOptionsBarPend: Partial<ChartOptionsBar>;
  public chartOptionsBarConflictos: Partial<ChartOptionsBar>;
  public chartOptionsBarPendAnnio: Partial<ChartOptionsBar>;
  public chartOptionsBarElevadosAnnio: Partial<ChartOptionsBar>;
  public chartOptions: Partial<ChartOptions>;

  dataSourceRespuesta = new MatTableDataSource([]);
  dataSource2 = new MatTableDataSource([]);

  interval;
  ultima_actualizacion;

  // metodo get para facil acceso a los campos del formulario
  get f() {
    return this.formularioRegistro.controls;
  }
  
  constructor(
    public serviciosService: ServiciosService,
    private formBuilder: FormBuilder,
    private cg: ChangeDetectorRef,
    public globals: Globals
  ) {
    this.generarListaAnnios()
    this.cargarVicepresidenciasAutocompletar()
    this.cargarGerenciaAutocompletar()
    this.cargarPaisesAutocompletar()
    this.cargarAreasAutocompletar()
    this.cargarLugarAutocompletar()
    this.cargarTipoConflictoAutocompletar()
    this.cargarTipoRespuestaAutocompletar()

    this.cargarTercerosAutocompletar()
    this.cargarUsuariosAutocompletar()
    this.cargarConflictosAutocompletar()
  }

  ngOnInit() {
    window.clearInterval(this.interval);
    Object.assign(this, { single });
    this.formularioRegistro = this.formBuilder.group({
      pais: ["", Validators.required],
      gerencia: ["", Validators.required],
      area: ["", Validators.required],
      vicepresidencia: ["", Validators.required],
      lugar: ["", Validators.required],
      tipo_conflicto:["", Validators.required],
      tipo_conflicto_id:["", Validators.required],
      annio: [this.anio_actual.toString()],
      fecha_ini:[moment().format('YYYY-MM-DD')],
      fecha_fin:[moment().format('YYYY-MM-DD')],
    });

    this.formularioTerceros = this.formBuilder.group({
      tercero: [""],
      usuario: [""],
      conflicto: [""],
      terceros_list: [],
      usuario_list: [],
      conflicto_list: [],
    })
    this.usuario = {
      pais: 'TODOS',
      gerencia: 'TODOS',
      area: 'TODOS',
      vicepresidencia: 'TODOS',
      lugar: 'TODOS',
      tipo_conflicto: 'TODOS',
      tipo_conflicto_id: 0,
      annio: this.anio_actual,
      is_year: this.is_year ? 1 : 0,
      fecha_ini: moment().format('YYYY-MM-DD'),
      fecha_fin: moment().format('YYYY-MM-DD'),
    }

    this.terceros = {
      tercero: '',
      usuario: '',
      conflicto: '',
    }

    this.annio_actualy = this.usuario.annio;

    this.list_terceros = this.controlTerceros.valueChanges.pipe(
      startWith(""),
      map(value => this._filtroTerc(value,'tercero'))
    );
    this.list_usuarios = this.controlUsuarios.valueChanges.pipe(
      startWith(""),
      map(value => this._filtroTerc(value,'usuario'))
    );
    this.list_conflictos = this.controlConflicto.valueChanges.pipe(
      startWith(""),
      map(value => this._filtroTerc(value,'conflicto'))
    );


    this.list_paises = this.controlPais.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value,'pais'))
    );
    this.list_gerencia = this.controlGerencia.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value,'gerencia'))
    );
    this.list_vicepresidencias = this.controlVicepresidencia.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value,'vicepresidencia'))
    );
    this.list_area = this.controlArea.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value,'area'))
    );
    this.list_lugar = this.controlLugar.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value,'lugar'))
    );
    this.list_tipo_conflicto = this.controlTipoConflicto.valueChanges.pipe(
      startWith(""),
      map(value => this._filtro(value,'tipo_conflicto_espanol'))
    );
    
    this.generar_reporte(this.usuario)
    this.ultima_actualizacion = moment(new Date()).utc(true).format('DD/MM/YYYY HH:mm');
    //console.log(this.ultima_actualizacion);
    this.interval = setInterval(() => {
      //console.log("entra a esto");
      this.ultima_actualizacion = moment(new Date()).utc(true).format('DD/MM/YYYY HH:mm');
      this.generar_reporte(this.usuario)
    }, 60000);
  }

  ngOnChanges() {
    this.usuario = new Usuario();
  }

  applyFilter(filterValue: string) {
    this.dataSourceRespuesta.filter = filterValue.trim().toLowerCase();
    this.dataSource2.filter = filterValue.trim().toLowerCase();
  }

  private _filtro(value: string, columna: string): string[] {
    const filterValue = value.toLowerCase();
    return this.listasReporte[columna].filter(option => option.toLowerCase().includes(filterValue));
  }

  private _filtroTerc(value: string, columna: string): string[] {
    const filterValue = value.toLowerCase();
    return this.listasTerceros[columna].filter(option => option.toLowerCase().includes(filterValue));
  }

  private extractColumn(arr, column) {
    return arr.map(x => x[column])
  }

  accent_fold (s) {
    var accent_map = {'á':'a', 'é':'e', 'í':'i', 'ó':'o', 'ú':'u', 'Á':'a', 'É':'e', 'Í':'i','Ó':'o', 'Ú':'u'};
    if (!s) { return ''; }
    var ret = '';
    for (var i = 0; i < s.length; i++) {
      ret += accent_map[s.charAt(i)] || s.charAt(i);
    }
    return ret;
  };

  onKeyUpProveedores(e) {
    let text = e.target.value
    let new_array = []
    if(text.length > 0){
      let terceros = this.extractColumn(this.list_terceros_all, 'valor');
      for (let i = 0; i < terceros.length; i++) {
        ////console.log("terceros[i] = ", terceros[i])
        let val = this.accent_fold(terceros[i]).toUpperCase();
        let value = val.search(text.toUpperCase()) != -1 ? terceros[i] : false
        if(value){
          new_array.push(terceros[i])
          ////console.log(new_array)
          this.listasTerceros["terceros"] = new_array
        }
      }
    }else{
      this.listasTerceros["terceros"] = this.extractColumn(this.list_terceros_all, 'valor');
    }
  }

  onKeyUpUsurios(e) {
    let text = e.target.value
    let new_array = []
    if(text.length > 0){
      let terceros = this.extractColumn(this.list_usuarios_all, 'nombre_completo');
      for (let i = 0; i < terceros.length; i++) {
        ////console.log("terceros[i] = ", terceros[i])
        let val = this.accent_fold(terceros[i]).toUpperCase()
        let value = val.search(text.toUpperCase()) != -1 ? terceros[i] : false
        if(value){
          new_array.push(terceros[i])
          this.listasTerceros["usuarios"] = new_array
        }
      }
    }else{
      this.listasTerceros["usuarios"] = this.extractColumn(this.list_usuarios_all, 'nombre_completo');
    }
  }

  onKeyUpConflictos(e) {
    let text = e.target.value
    let terceros = this.extractColumn(this.list_conflictos_all, 'tipo_conflicto_espanol');
    
    let new_array = []
    if(text.length > 0){
      for (let i = 0; i < terceros.length; i++) {
        let val = this.accent_fold(terceros[i]).toUpperCase()
        let value = val.search(text.toUpperCase()) != -1 ? terceros[i] : false
        if(value){
          new_array.push(terceros[i])
          this.listasTerceros["conflictos"] = new_array
        }
      }
    }else{
      this.listasTerceros["conflictos"] = this.extractColumn(this.list_conflictos_all, 'tipo_conflicto_espanol');
    }
  }

  changeForDate() {
    this.annio_actualy = parseInt(this.usuario.annio);
    //console.log("annio = ", this.annio_actualy)
    this.minDate = new Date(this.annio_actualy, 0, 1); //minDate is 1st Jan 2019
    this.maxDate = new Date((this.annio_actualy + 1), 0, 1); //maxDate is 1st Jan 2020
    let new_fechaini = this.annio_actualy +'-'+ this.month_actualy +'-'+ this.day_actualy
    let new_fechafin = this.annio_actualy +'-'+ this.month_actualy +'-'+ this.day_actualy
    this.usuario.fecha_ini = moment(new_fechaini).format('YYYY-MM-DD');
    this.usuario.fecha_fin = moment(new_fechafin).format('YYYY-MM-DD');
    this.formularioRegistro.patchValue({
      fecha_ini: moment(new_fechaini).format('YYYY-MM-DD'), 
      fecha_fin: moment(new_fechaini).format('YYYY-MM-DD'), 
    });
    this.is_year = !this.is_year
  }

  generarListaAnnios(){
    for(let i=2018;i<=this.anio_actual;i++){
      this.listaAnnios.push(i)
    }
  }

  cargarTercerosAutocompletar() {   
    this.serviciosService.consultarTerceros().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        this.list_terceros_all = datos["reporte"];
        this.listasTerceros["terceros"] = this.extractColumn(datos["reporte"], 'valor');
      }
    });
  }

  cargarUsuariosAutocompletar() {   
    this.serviciosService.consultarUsuariosReport().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        this.lista_funcionarios = datos["reporte"];
        this.list_usuarios_all = datos["reporte"];
        this.lista_funcionarios_all = datos["reporte"];
        this.listasTerceros["usuarios"] = this.extractColumn(datos["reporte"], 'nombre_completo');
      }
    });
  }

  cargarConflictosAutocompletar() {   
    this.serviciosService.consultarPreguntas().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        this.lista_preguntas = datos["reporte"];
        this.lista_preguntas_all = datos["reporte"];
        this.list_conflictos_all = datos["reporte"];
        this.listasTerceros["conflictos"] = this.extractColumn(datos["reporte"], 'tipo_conflicto_espanol');
      }
    });
  }

  cargarVicepresidenciasAutocompletar() {
    this.serviciosService.consultaVicepresidencias().subscribe(datos => {
      //console.log(datos)
      if (datos["status"] && datos["status"] === 200) {
        datos["lista"].push({vicepresidencia: 'TODOS'})
        this.listasReporte["vicepresidencia"] = this.extractColumn(datos["lista"], 'vicepresidencia');
      }
    });
  }

  cargarPaisesAutocompletar() {
    this.serviciosService.consultaPaises().subscribe(datos => {
      
      if (datos["status"] && datos["status"] === 200) {
        datos["lista"].push({pais: 'TODOS'})
        this.listasReporte["pais"] = this.extractColumn(datos["lista"], 'pais');
       
      }
    });
  }

  cargarAreasAutocompletar() {
    this.serviciosService.consultarAreas().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        datos["lista"].push({area: 'TODOS'})
        this.listasReporte["area"] = this.extractColumn(datos["lista"], 'area');
      }
    });
  }

  cargarGerenciaAutocompletar() {
    this.serviciosService.consultaGerencia().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        datos["lista"].push({direccion_gerencia: 'TODOS'})
        this.listasReporte["gerencia"] = this.extractColumn(datos["lista"],'direccion_gerencia');
      }
    });
  }

  cargarLugarAutocompletar() {
    this.serviciosService.consultarLugar().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        datos["lista"].push({lugar: 'TODOS'})
        this.listasReporte["lugar"] = this.extractColumn(datos["lista"],'lugar');
      }
    });
  }

  cargarTipoConflictoAutocompletar() {
    this.serviciosService.consultarTipoConflicto().subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        datos["lista"].push({tipo_conflicto_espanol: 'TODOS'})
        this.tipo_conflictos_all = datos["lista"];
        this.listasReporte["tipo_conflicto"] = this.extractColumn(datos["lista"],'tipo_conflicto_espanol');

      }
    });
  }

  cargarTipoRespuestaAutocompletar() {
    this.serviciosService.consultarTipoRespuesta().subscribe(datos => {
      
      if (datos["status"] && datos["status"] === 200) {
        //datos["lista"].push({tipo_conflicto_espanol: 'TODOS'})
        this.tipo_respuestas_all = datos["lista"];
       
        this.listasReporteRespuesta["tipo_conflicto"] = this.extractColumn(datos["lista"],'tipo_conflicto_espanol');

      }
    });
  }


  cargarUsuariosActivos() {
    this.serviciosService.consultarUsuariosActivos({}).subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        this.cantidad_usuarios = datos["cantidad_activos"];
      }
    });
  }

  cargarFuncionariosRespuesta() {
    this.serviciosService.consultarRespuestasFuncionario({}).subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
       
        this.respuesta_funcionarios = datos["cantidad_funcionarios_respuesta"].filter(x => x.respondidos == 1).length;
      }
    });
  }

  clear_form() {
    this.usuario = {
      pais: 'TODOS',
      gerencia: 'TODOS',
      area: 'TODOS',
      vicepresidencia: 'TODOS',
      lugar: 'TODOS',
      tipo_conflicto: 'TODOS',
      tipo_conflicto_id: 0,
      annio: this.anio_actual,
      is_year: this.is_year ? 1 : 0,
      fecha_ini: moment().format('YYYY-MM-DD'),
      fecha_fin: moment().format('YYYY-MM-DD'),
    }

    this.terceros = {
      tercero: '',
      usuario: '',
      conflicto: '',
    }
  }

  tabChanged(e) {
    //console.log("tab = ", e)
    window.clearInterval(this.interval)
    this.ultima_actualizacion = moment(new Date()).utc(true).format('DD/MM/YYYY HH:mm');
    var key = e.index
    this.identity_tab = key
    this.usuario = {
      pais: 'TODOS',
      gerencia: 'TODOS',
      area: 'TODOS',
      vicepresidencia: 'TODOS',
      lugar: 'TODOS',
      tipo_conflicto: 'TODOS',
      tipo_conflicto_id: 0,
      annio: this.anio_actual,
      is_year: this.is_year ? 1 : 0,
      fecha_ini: moment().format('YYYY-MM-DD'),
      fecha_fin: moment().format('YYYY-MM-DD'),
    }

    this.terceros = {
      tercero: '',
      usuario: '',
      conflicto: '',
    }
    if(key == 3){
      this.usuario['tipo_conflicto']="11. DILEMAS ÉTICOS"
      this.view_form = 2;
      this.view_form_respuestas=true;
      
    }else if(key == 4){
      this.view_form_respuestas=false;
      this.view_form = 2;
    }else{
      this.view_form_respuestas=false;
      this.view_form = 1;
    }
    switch (this.identity_tab) {
      case 0:
        //console.log("entra a esto antes");        
        this.generar_reporte(this.usuario)
        this.interval = setInterval(() => {
          //console.log("entra a esto");
          this.ultima_actualizacion = moment(new Date()).utc(true).format('DD/MM/YYYY HH:mm');
          this.generar_reporte(this.usuario)
        }, 60000);
        break;
      case 1:        
        this.generar_reporte_administrativo(this.usuario)
        this.interval = setInterval(() => {
          this.ultima_actualizacion = moment(new Date()).utc(true).format('DD/MM/YYYY HH:mm');
          this.generar_reporte_administrativo(this.usuario)
        }, 60000);
        break;
      case 2:        
        this.generar_reporte_conflictos(this.usuario)
        this.interval = setInterval(() => {
          this.ultima_actualizacion = moment(new Date()).utc(true).format('DD/MM/YYYY HH:mm');
          this.generar_reporte_conflictos(this.usuario)
        }, 60000);
        break;
      case 3:        
        this.generar_reporte_respuestas(this.usuario)
        this.interval = setInterval(() => {
          this.ultima_actualizacion = moment(new Date()).utc(true).format('DD/MM/YYYY HH:mm');
          this.generar_reporte_respuestas(this.usuario)
        }, 60000);
        break;
      default:
        break;
    }
  }

  filtrar (tipo){
    
    this.loading = true
    let fecha_inicial = moment(this.formularioRegistro.value.fecha_ini).format('YYYY-MM-DD')
    let fecha_final = moment(this.formularioRegistro.value.fecha_fin).format('YYYY-MM-DD')
    
    this.usuario["fecha_ini"] = fecha_inicial;
    this.usuario["fecha_fin"] = fecha_final;
    this.usuario["is_year"] = this.is_year ? 1 : 0;
    if(tipo=="tipo1"){
      this.usuario["tipo_conflicto_id"] = this.usuario["tipo_conflicto"] != 'TODOS' ? this.tipo_conflictos_all.find(x => x.tipo_conflicto_espanol == this.usuario["tipo_conflicto"])["idtbl_conflicto"] : 0;
    }

    if(tipo=="tipo2"){
      this.usuario["tipo_conflicto_id"] = this.usuario["tipo_conflicto"] != 'TODOS' ? this.tipo_respuestas_all.find(x => x.tipo_conflicto_espanol == this.usuario["tipo_conflicto"])["idtbl_conflicto"] : 0;
   
    }
    //console.log(this.identity_tab)
    switch (this.identity_tab) {
      case 0:
        this.generar_reporte(this.usuario)
        break;
      case 1:
        this.generar_reporte_administrativo(this.usuario)
        break;
      case 2:
        this.generar_reporte_conflictos(this.usuario)
        break;
      case 3:
        this.generar_reporte_respuestas(this.usuario)
        break;
      default:
        break;
    }
  }


  redondear (number:number = 0) {
    let round_number = !Number.isNaN(Math.round(number)) ? Math.round(number) : 0
    return round_number;
  }
  
  onNgModelChange (e,type){

    if(this.terceros_options.length > 0 || this.usuarios_options.length > 0 || this.conflictos_options.length > 0){
      if(this.terceros_options.length > 0){
        this.show_button_terceros = true
      }else{
        this.show_button_terceros = false
      }

      if(this.usuarios_options.length > 0){
        this.show_button_funcionarios = true
      }else{
        this.show_button_funcionarios = false
      }
      if(this.conflictos_options.length > 0){
        this.show_button_conflictos = true
      }else{
        this.show_button_conflictos = false
      }
      let usuarios_ids = [];
      let conflictos_ids = [];
      this.usuarios_options.forEach(e => {
        let id = this.lista_funcionarios_all.find(x => x.nombre_completo === e)["idtbl_funcionario"];
        usuarios_ids.push(id)
      });
      this.conflictos_options.forEach(e => {
        let id = this.lista_preguntas_all.find(x => x.tipo_conflicto_espanol === e)["idtbl_conflicto"];
        conflictos_ids.push(id)
      });
  
      let data = {
        terceros: this.terceros_options,
        usuarios: usuarios_ids,
        conflictos: conflictos_ids
      }
      this.serviciosService.generarFiltros(data).subscribe(datos => {
        if (datos["status"] && datos["status"] === 200) {
          if(type == 'terceros'){
            this.lista_preguntas = datos["reporte"]["conflictos"];
            this.listasTerceros["conflictos"] = this.extractColumn(datos["reporte"]["conflictos"], 'tipo_conflicto_espanol');

            this.lista_funcionarios = datos["reporte"]["usuarios"];
            this.listasTerceros["usuarios"] = this.extractColumn(datos["reporte"]["usuarios"], 'nombre_completo');
          }
          if(type == 'usuarios'){
            this.listasTerceros["terceros"] = this.extractColumn(datos["reporte"]["terceros"], 'valor');

            this.lista_preguntas = datos["reporte"]["conflictos"];
            this.listasTerceros["conflictos"] = this.extractColumn(datos["reporte"]["conflictos"], 'tipo_conflicto_espanol');
          }
          if(type == 'conflictos'){
            this.listasTerceros["terceros"] = this.extractColumn(datos["reporte"]["terceros"], 'valor');

            this.lista_funcionarios = datos["reporte"]["usuarios"];
            this.listasTerceros["usuarios"] = this.extractColumn(datos["reporte"]["usuarios"], 'nombre_completo');
          }
        }
      });
      //if(this.usuarios_options.length > 0 || this.terceros_options.length > 0){
        this.serviciosService.verReporte(data).subscribe(datos => {
          if (datos["status"] && datos["status"] === 200) {
            let envio = [];
            let validador;
            for(let i = 0; i < datos.reporte.length; i++){
              validador = 0;
              for(let x = 0; x < envio.length; x++){
                if(envio[x].idtbl_respuesta_conflicto == datos.reporte[i].idtbl_respuesta_conflicto){
                  envio[x] = datos.reporte[i];
                  validador++;
                }
              }
              if(validador == 0){
                envio.push(datos.reporte[i]);
              }            
            }
            this.bodyHojaVida = envio;
            
            for(let i = 0; i < this.bodyHojaVida.length; i++){
              this.bodyHojaVida[i].fecha_registro = moment(this.bodyHojaVida[i].fecha_registro).format('DD/MM/YYYY');
            }
            this.dataSource = new MatTableDataSource<FuncionariosElement>(this.bodyHojaVida);
            this.dataSource.paginator = this.paginator;
            this.ver_todo = true;
          }
        })
    }else{
      this.show_button_terceros = false
      this.show_button_funcionarios = false
      this.show_button_conflictos = false

      this.ver_todo = false;
      this.ver = false;
      this.verConflicto = [];
      this.headerTable = [];
      this.bodyTable = [];
      this.headerAdicional = [];
      this.bodyAdicional = [];
      this.verRespuestaConfilcto = [];
      this.comentariosJefe = true;
      this.comentariosCompliance = true;
      this.pregunta = '';
      this.nombre_funcionario = '';
      this.identificadorActual = false;
      this.comentariosAntiguos = [];
      this.validarComentariosAntiguos = false;
      
      this.dataSource = new MatTableDataSource<FuncionariosElement>([]);
      this.dataSource.paginator = this.paginator;
      this.listasTerceros["terceros"] = this.extractColumn(this.list_terceros_all, 'valor');
      this.listasTerceros["usuarios"] = this.extractColumn(this.list_usuarios_all, 'nombre_completo');
      this.listasTerceros["conflictos"] = this.extractColumn(this.list_conflictos_all, 'tipo_conflicto_espanol');
      
    }
    this.cg.detectChanges();
  }

  verProceso (e) {
    this.ver = false;
    this.verConflicto = [];
    this.headerTable = [];
    this.bodyTable = [];
    this.headerAdicional = [];
    this.bodyAdicional = [];
    this.verRespuestaConfilcto = [];
    this.comentariosJefe = true;
    this.comentariosCompliance = true;
    this.pregunta = e.pregunta;
    this.nombre_funcionario = e.nombre_completo;
    this.identificadorActual = e.idtbl_proceso_conflicto;
    this.comentariosAntiguos = [];
    this.validarComentariosAntiguos = false;
    this.selected_row = e.idtbl_respuesta_conflicto
    var identificadorVerConflicto = 0;

    this.serviciosService.verProceso({ id_conflicto: e.idtbl_respuesta_conflicto }).subscribe(datos => {
      //console.log("datos = ", datos)
      if (datos["status"] && datos["status"] === 200) {
        if(datos.reporte.length == 0){
          this.comentariosCompliance = false;
        }else{
          for(let i = 0; i < datos.reporte.length; i++){
            datos.reporte[i].fecha_registro = moment(datos.reporte[i].fecha_registro).format('DD/MM/YYYY');
          }
          this.verConflicto = datos.reporte;
          identificadorVerConflicto = e.id_conflicto;
        }
        this.serviciosService.listaConflictos({ id_conflicto: e.idtbl_respuesta_conflicto }).subscribe(datos2 => {

          if (datos2["status"] && datos2["status"] === 200) {
            //SPLIT FECHA SIN HORA
            datos2.reporte.forEach(el => {
              if(el.valor && (el.id_tipo_respuesta == 35  || el.id_tipo_respuesta == 36)){
                el.valor = el.valor.split("T")[0];
              }
            });
          

            for(let i = 0; i < datos2.reporte.length; i++){
              if(this.idioma == "Es" || this.idioma == "ESPANOL" || this.idioma == "ESPAÑOL"){
                this.headerTable[i] = datos2.reporte[i].conflicto_espanol;
              }else{
                this.headerTable[i] = datos2.reporte[i].conflicto_ingles;
              }
              this.bodyTable[i] = datos2.reporte[i].valor;
            }
            this.ver = true;
          }
        });
      }
    })
  }

  generar_reporte (data) {
    let arr_bar_conflicts = [];
    let arr_bar_pendients = [];
    let arr_bar_meses = [];

    this.serviciosService.generarReporte(data).subscribe(datos => {
      if (datos["status"] && datos["status"] === 200) {
        let data_cantidad_usuarios = datos["reporte"]["activos"];

        let data_respuesta_funcionarios = datos["reporte"]["respuestas"];
       
        let data_conflicto_funcionarios = datos["reporte"]["conflictos"];
        let data_conflicto_meses = datos["reporte"]["bar"];
        //this.listasReporte["vicepresidencia"] = this.extractColumn(datos["lista"], 'vicepresidencia');

        // GRAFIC BAR CHART
        let key_bar = Object.keys(data_conflicto_meses)
        //let value_bar = Object.values(data_conflicto_meses)
        if(key_bar){
          key_bar.forEach(k => {
            let i = parseInt(k)
            let result = data_conflicto_meses[i].reduce((prev, current, index, arr) => {
              // Compruebo si ya existe el elemento
              let exists = prev.find(x => x.idtbl_funcionario === current.idtbl_funcionario);
              // Si no existe lo creo con un array vacío en VALOR
              if (!exists) {
                exists = {idtbl_funcionario: current.idtbl_funcionario};
                prev.push(exists);
              }
              // Si el elemento actual tiene VALOR lo añado al array del
              // elemento existente
              if (current.VALOR != null){
                // Convierto el valor a numérico reemplazando el carácter separador
                let val = parseFloat(current.VALOR.replace(',','.'));
                // Si es un valor numérico válido lo añado al resultado
                if (!isNaN(val)){
                  exists.VALOR.push(val);
                }
              }
              // Devuelvo el array resultado para la nueva iteración
              return prev;
            }, []);
            let conflicts = result.length
           
            
            //let pendient = data_conflicto_meses[i].reduce((a, b) => +a + +b.pendientes, 0);
            arr_bar_conflicts.push(conflicts)
            arr_bar_pendients.push(data_conflicto_meses[i].length)
            arr_bar_meses.push(this.month[(i-1)])
          });
        }
        
        // TARJETA ACTIVOS
        if(data_cantidad_usuarios.length > 0){
          var activos_filter =  data_cantidad_usuarios.filter(item=>item.estado=="ACTIVO" || item.estado=="Activo" || item.estado=="activo");
          this.cantidad_usuarios = activos_filter.length
          this.cantidad_usuarios_total = data_cantidad_usuarios.length > 0 ? Math.round((this.cantidad_usuarios * 100) / data_cantidad_usuarios.length) : 0
        }else{
          this.cantidad_usuarios = 0
          this.cantidad_usuarios_total = 0
        }

        //TARJETA RESPUESTAS
        if(data_respuesta_funcionarios.length > 0){
          var data_repuesta_filter =  data_respuesta_funcionarios.filter(function(d) {
            return d.respondidos == 1;
          });
          this.respuesta_funcionarios = data_repuesta_filter.length
          this.cantidad_respuesta_funcionarios_total = data_respuesta_funcionarios.length > 0 ? Math.round((this.respuesta_funcionarios * 100) / data_respuesta_funcionarios.length) : 0
        }else{
          this.respuesta_funcionarios = 0;
          this.cantidad_respuesta_funcionarios_total = 0;
        }

        //console.log("data_conflicto_funcionarios = ", data_conflicto_funcionarios.length)
        //TARJETA CONFLICTOS
        if(data_conflicto_funcionarios.length > 0){
          var data_conflicto_pendientes_filter =  data_conflicto_funcionarios.filter(function(d) {
            return d.pendientes > 0; //validar
          });
          let realizados = this.respuesta_funcionarios//data_conflicto_funcionarios.length - data_conflicto_pendientes_filter.length
          let pendientes = this.cantidad_usuarios - this.respuesta_funcionarios//data_conflicto_pendientes_filter.length
          this.conflictos_activos = data_conflicto_funcionarios.length
          this.cantidad_conflictos_funcionarios_total = Math.round((this.conflictos_activos * 100) / data_conflicto_funcionarios.length)
          // PIE CHARTS
          //console.log("entroooo ")
          this.chartOptions = {
            series: [realizados, pendientes],
            chart: {
              width: 380,
              type: "pie",
            },
            labels: ["Realizados", "Pendientes"],
            colors: ['#001871', '#8FA73B'],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                  },
                  legend: {
                    position: "bottom"
                  }
                }
              }
            ]
          };
        }else{
          this.conflictos_activos = 0
          this.cantidad_conflictos_funcionarios_total = 0

          this.chartOptions = {
            series: [0, 0],
            chart: {
              width: 380,
              type: "pie",
            },
            labels: ["Realizados", "Pendientes"],
            colors: ['#001871', '#8FA73B'],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200,
                  },
                  legend: {
                    position: "bottom"
                  }
                }
              }
            ]
          };
        }


        this.chartOptionsBar = {
          series: [
            {
              name: "Cantidad de Usuarios",
              data: arr_bar_conflicts,
              color: '#001871'
            },
            {
              name: "Cantidad de Conflictos",
              data: arr_bar_pendients,
              color: '#8FA73B'
            },
          ],
          chart: {
            type: "bar",
            height: 350,
            width:750
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              //endingShape: "rounded",
              dataLabels: {
                position: "top" // top, center, bottom
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + "";
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
              colors: ["#304758"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            categories: arr_bar_meses
          },
          yaxis: {
            title: {
              text: "Cantidad de Usuarios"
            }
          },
          fill: {
            opacity: 1,
            colors: ['#001871', '#8FA73B']
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " ";
              }
            }
          }
        };

        this.loading = false
      }
    });
  }
  generar_reporte_administrativo (data) {
    this.serviciosService.generarReporteAdministrativo(data).subscribe(datos => {

      if (datos["status"] && datos["status"] === 200) {
        let data_administrados = datos["reporte"]["target_administrados"];
        let bar_data_administrados = datos["reporte"]["bar_administrados"];
        let data_pendientes = datos["reporte"]["target_pendientes"];
        let bar_data_pendientes = datos["reporte"]["bar_pendientes"];

        //ATENDIDOS Y ELEVADOS
        let data_pendientes_compliance = datos["reporte"]["target_pendientes_compliance"];
        let bar_data_pendientes_compliance = datos["reporte"]["bar_pendientes_compliance"];

        //PENDIENTES ELEVADOS POR AÑO
        let data_pendientes_annio = datos["reporte"]["target_pendientes_annio"];
        let bar_data_pendientes_annio = datos["reporte"]["bar_pendientes_annio"];

        let data_promedio_annio = datos["reporte"]["target_promedio_annio"];
        let bar_data_promedio_annio = datos["reporte"]["bar_promedio_annio"];

        // ADMINISTRADOS
        let riesgo_tratado = data_administrados["Riesgo identificado y tratado"] || false; 
        let sit_reportada = data_administrados["Situación reportada no representa riesgo actualmente"] || false; 
        
        let result_riesgo_repor_administrados = {}
        if(riesgo_tratado){
          result_riesgo_repor_administrados = riesgo_tratado.reduce(function(previousValue, currentValue) {
            return {
              accion: currentValue.accion,
              cantidad: previousValue.cantidad + currentValue.cantidad,
              estado_conflicto: currentValue.estado_conflicto,
              mes: currentValue.mes,
            }
          });
        }

        let result_sit_repor_administrados = {}
        if(sit_reportada){
          result_sit_repor_administrados = sit_reportada.reduce(function(previousValue, currentValue) {
            return {
              accion: currentValue.accion,
              cantidad: previousValue.cantidad + currentValue.cantidad,
              estado_conflicto: currentValue.estado_conflicto,
              mes: currentValue.mes,
            }
          });
        }

        // GRAFIC BAR CHART
        let key_bar = Object.keys(bar_data_administrados)
        //let value_bar = Object.values(data_conflicto_meses)
        let array_riesgos_admin = []
        let array_sit_admin = []
        let array_month_admin = []


        if(key_bar){
          key_bar.forEach(k => {
            let i = parseInt(k)
            //console.log("i = ", i)
            var exist_riesgo = bar_data_administrados[i].find(x => x.accion == 'Riesgo identificado y tratado')
            var exist_no_riesgo = bar_data_administrados[i].find(x => x.accion == 'Situación reportada no representa riesgo actualmente')
            var riesgo = exist_riesgo ? exist_riesgo.cantidad : 0;
            var no_riesgo = exist_no_riesgo ? exist_no_riesgo.cantidad : 0;
            array_sit_admin.push(no_riesgo)
            array_riesgos_admin.push(riesgo)
            array_month_admin.push(this.month[(i-1)])
          });
        }
        
        this.cantidad_riesgo_identificado = Object.keys(result_riesgo_repor_administrados).length > 0 ? result_riesgo_repor_administrados["cantidad"] : 0;
        this.cantidad_no_riesgo = Object.keys(result_sit_repor_administrados).length > 0 ? result_sit_repor_administrados["cantidad"] : 0;
        this.total_administrados = this.cantidad_riesgo_identificado + this.cantidad_no_riesgo

        this.chartOptionsBarAdmin = {
          series: [
            {
              name: "Riesgo identificado y tratado",
              data: array_riesgos_admin,
              color: '#001871'
            },
            {
              name: "Situación reportada no representa riesgo actualmente",
              data: array_sit_admin,
              color: '#8FA73B'
            },
          ],
          chart: {
            type: "bar",
            height: 350,
            width:750
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              //endingShape: "rounded",
              dataLabels: {
                position: "top" // top, center, bottom
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + "";
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
              colors: ["#304758"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            categories: array_month_admin
          },
          yaxis: {
            title: {
              text: "Cantidad"
            }
          },
          fill: {
            opacity: 1,
            colors: ['#001871', '#8FA73B']
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " ";
              }
            }
          }
        };
        
        //PENDIENTES
        let act_formulario = data_pendientes["Atendido por Compliance"] || false; 
        let registrado = data_pendientes["Registrado"] || false; 
        let elevado_compliance = data_pendientes["Elevado a Compliance"] || false; 

        //PENDIENTES ANNIO
        let elevado_compliance_annio = data_pendientes_annio["Elevado a Compliance"] || false; 
        let admin_compliance_annio = data_pendientes_annio["Atendido por Compliance"] || false; 
        
        let result_act_formulario_pendientes = {}
        if(act_formulario){
          result_act_formulario_pendientes = act_formulario.reduce(function(previousValue, currentValue) {
            return {
              accion: currentValue.accion,
              cantidad: previousValue.cantidad + currentValue.cantidad,
              estado_conflicto: currentValue.estado_conflicto,
              mes: currentValue.mes,
            }
          });
        }
        //console.log("result_act_formulario_pendientes = ", result_act_formulario_pendientes)
        let result_registrados_pendientes = {}
        if(registrado){
          result_registrados_pendientes = registrado.reduce(function(previousValue, currentValue) {
            return {
              accion: currentValue.accion,
              cantidad: previousValue.cantidad + currentValue.cantidad,
              estado_conflicto: currentValue.estado_conflicto,
              mes: currentValue.mes,
            }
          });
        }
        //console.log("result_registrados_pendientes = ", result_registrados_pendientes)
        let result_elevado_compliance_pendientes = {}
        if(elevado_compliance){
          result_elevado_compliance_pendientes = elevado_compliance.reduce(function(previousValue, currentValue) {
            return {
              accion: currentValue.accion,
              cantidad: previousValue.cantidad + currentValue.cantidad,
              estado_conflicto: currentValue.estado_conflicto,
              mes: currentValue.mes,
            }
          });
        }

        // GRAFIC BAR CHART
        let key_bar_pend = Object.keys(bar_data_pendientes)
        let key_bar_pend_compliance = Object.keys(bar_data_pendientes_compliance)
        //let value_bar = Object.values(data_conflicto_meses)
        let array_registrado_pend = [];
        let array_elev_pend = [];
        let array_atend_pend = [];
        let array_month_pend = [];

       
        if(key_bar_pend){
          key_bar_pend.forEach(k => {
            let i = parseInt(k)
            //console.log("i = ", i)
          
            var exist_registrado = bar_data_pendientes[i].find(x => x.estado_conflicto == 'Registrado')
            var exist_atendido = bar_data_pendientes[i].find(x => x.estado_conflicto == 'Atendido por Compliance')
            var exist_elevado = bar_data_pendientes[i].find(x => x.estado_conflicto == 'Elevado a Compliance')

            var registrado = exist_registrado ? exist_registrado.cantidad : 0
            var atendido = exist_atendido ? exist_atendido.cantidad : 0
            var elevado = exist_elevado ? exist_elevado.cantidad : 0

            array_registrado_pend.push(registrado)
            array_elev_pend.push(elevado)
            array_atend_pend.push(atendido)

           array_month_pend.push(this.month[(i-1)])
          });
        }

        // if(key_bar_pend_compliance){
        //   key_bar_pend_compliance.forEach(k => {
        //     let i = parseInt(k)
        //     //console.log("i = ", i)

          
        //     var exist_atendido = bar_data_pendientes_compliance[i].find(x => x.estado_conflicto == 'Atendido por Compliance')
        //     var exist_elevado = bar_data_pendientes_compliance[i].find(x => x.estado_conflicto == 'Elevado a Compliance')

           
        //     var atendido = exist_atendido ? exist_atendido.cantidad : 0
        //     var elevado = exist_elevado ? exist_elevado.cantidad : 0

        
        //     array_elev_pend.push(elevado)
        //     array_atend_pend.push(atendido)

        

        //     array_month_pend.push(this.month[(i-1)])
        //   });
        // }

        this.cantidad_registrados_compliance = Object.keys(result_registrados_pendientes).length > 0 ? result_registrados_pendientes["cantidad"] : 0;
        this.cantidad_atendidos_compliance = Object.keys(result_act_formulario_pendientes).length > 0 ? result_act_formulario_pendientes["cantidad"] : 0;
        this.cantidad_elevados_compliance = Object.keys(result_elevado_compliance_pendientes).length > 0 ? result_elevado_compliance_pendientes["cantidad"] : 0;
        this.total_pendientes = this.cantidad_registrados_compliance + this.cantidad_elevados_compliance + this.cantidad_atendidos_compliance

        this.chartOptionsBarPend = {
          series: [
            {
              name: "Registrado",
              data: array_registrado_pend,
              color: '#001871'
            },
            {
              name: "Atendido por Compliance",
              data: array_atend_pend,
              color: '#8FA73B'
            },
            {
              name: "Elevado a Compliance",
              data: array_elev_pend,
              color: '#97999B'
            },
          ],
          chart: {
            type: "bar",
            height: 350,
            width:750
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
             // endingShape: "rounded",
              dataLabels: {
                position: "top" // top, center, bottom
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + "";
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
              colors: ["#304758"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            categories: array_month_pend
          },
          yaxis: {
            title: {
              text: "Cantidad"
            }
          },
          fill: {
            opacity: 1,
            colors: ['#001871', '#8FA73B', '#97999B']
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " ";
              }
            }
          }
        };


        /////////////////////////AÑO ELEVADOS
         //GRAFIC BAR CHART ANNIO

         

         let key_bar_pend_annio = Object.keys(bar_data_pendientes_annio)
         let array_elev_pend_annio = [];
         let array_atend_pend_annio = [];
         let array_annio_pend = [];

         if(key_bar_pend_annio){
          key_bar_pend_annio.forEach(k => {
            let i = parseInt(k)
            //console.log("i = ", i)

           
            var exist_elevado = bar_data_pendientes_annio[i].find(x => x.estado_conflicto == 'Elevado a Compliance')
            var exist_atendido = bar_data_pendientes_annio[i].find(x => x.estado_conflicto == 'Atendido por Compliance')
           
            var elevado = exist_elevado ? exist_elevado.cantidad : 0
            var atendido = exist_atendido ? exist_atendido.cantidad : 0
           
            array_elev_pend_annio.push(elevado)
            array_atend_pend_annio.push(atendido)
          
            array_annio_pend.push(i)
          });
        }

        //GRAFICA PROMEDIO

        let key_bar_prom_annio = Object.keys(bar_data_promedio_annio)
       
        let array_promedio_annio = [];
        let array_annio_prom=[]

        if(key_bar_prom_annio){
          key_bar_prom_annio.forEach(k => {
           let i = parseInt(k)
           //console.log("i = ", i)

          
            var exist_atendido = bar_data_promedio_annio[i].find(x => x.estado_conflicto == 'Atendido por Compliance')
          
          
           var atendido = exist_atendido ? exist_atendido.dias : 0
          
         
           //array_promedio_annio.push(Math.round(atendido))
           array_promedio_annio.push(parseInt(atendido))
         
           array_annio_prom.push(i)
         });
       }
        

        this.chartOptionsBarPendAnnio = {
          series: [
           
            {
              name: "Prom. días Atendido por Compliance",
              data: array_promedio_annio,
              color: '#001871'
            },
          ],
          chart: {
            type: "bar",
            height: 350,
            width:750
          },
          
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              //endingShape: "rounded",
              dataLabels: {
                position: "top" // top, center, bottom
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + "";
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
              colors: ["#304758"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            categories: array_annio_prom
          },
          yaxis: {
            title: {
              text: "Días Prom"
            }
          },
          fill: {
            opacity: 1,
            colors: ['#001871']
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " ";
              }
            }
          }
        };

        this.chartOptionsBarElevadosAnnio = {
          
          series: [
           
            {
              name: "Elevado a Compliance",
              data: array_elev_pend_annio,
              color: '#001871'
            },

            {
              name: "Atendido por Compliance",
              data: array_atend_pend_annio,
              color: '#8FA73B'
            },
          ],

         

          chart: {
            type: "bar",
            height: 350,
            width:750
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              //endingShape: "rounded",
              dataLabels: {
                position: "top" // top, center, bottom
              }
            }
          },
          
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + "";
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
              colors: ["#304758"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            categories: array_annio_pend
          },
          yaxis: {
            title: {
              text: "Cantidad"
            }
          },
          
          fill: {
            opacity: 1,
            colors: ['#001871', '#8FA73B']
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " ";
              }
            }
          }
        };

        this.loading = false
      }
    })
  }

  clear_filter_terceros() {
    this.terceros_options = [];

    if(this.usuarios_options.length > 0 || this.conflictos_options.length > 0){
      this.show_button_terceros = false
      let usuarios_ids = [];
      let conflictos_ids = [];
      this.usuarios_options.forEach(e => {
        let id = this.lista_funcionarios_all.find(x => x.nombre_completo === e)["idtbl_funcionario"];
        usuarios_ids.push(id)
      });
      this.conflictos_options.forEach(e => {
        let id = this.lista_preguntas_all.find(x => x.tipo_conflicto_espanol === e)["idtbl_conflicto"];
        conflictos_ids.push(id)
      });
  
      let data = {
        terceros: this.terceros_options,
        usuarios: usuarios_ids,
        conflictos: conflictos_ids
      }
      //if(this.usuarios_options.length > 0 || this.terceros_options.length > 0){
      this.serviciosService.verReporte(data).subscribe(datos => {
        if (datos["status"] && datos["status"] === 200) {
          let envio = [];
          let validador;
          for(let i = 0; i < datos.reporte.length; i++){
            validador = 0;
            for(let x = 0; x < envio.length; x++){
              if(envio[x].idtbl_respuesta_conflicto == datos.reporte[i].idtbl_respuesta_conflicto){
                envio[x] = datos.reporte[i];
                validador++;
              }
            }
            if(validador == 0){
              envio.push(datos.reporte[i]);
            }            
          }
          this.bodyHojaVida = envio;
          
          for(let i = 0; i < this.bodyHojaVida.length; i++){
            this.bodyHojaVida[i].fecha_registro = moment(this.bodyHojaVida[i].fecha_registro).format('DD/MM/YYYY');
          }
          this.dataSource = new MatTableDataSource<FuncionariosElement>(this.bodyHojaVida);
          this.dataSource.paginator = this.paginator;
          this.ver_todo = true;
        }
      })
    }else{
      this.listasTerceros["terceros"] = this.extractColumn(this.list_terceros_all, 'valor');
    }
    this.cg.detectChanges();
  }

  clear_filter_funcionarios() {
    this.usuarios_options = [];
    if(this.terceros_options.length > 0 || this.conflictos_options.length > 0){
      this.show_button_terceros = false
      let usuarios_ids = [];
      let conflictos_ids = [];
      this.usuarios_options.forEach(e => {
        let id = this.lista_funcionarios_all.find(x => x.nombre_completo === e)["idtbl_funcionario"];
        usuarios_ids.push(id)
      });
      this.conflictos_options.forEach(e => {
        let id = this.lista_preguntas_all.find(x => x.tipo_conflicto_espanol === e)["idtbl_conflicto"];
        conflictos_ids.push(id)
      });
  
      let data = {
        terceros: this.terceros_options,
        usuarios: usuarios_ids,
        conflictos: conflictos_ids
      }
      //if(this.usuarios_options.length > 0 || this.terceros_options.length > 0){
      this.serviciosService.verReporte(data).subscribe(datos => {
        if (datos["status"] && datos["status"] === 200) {
          let envio = [];
          let validador;
          for(let i = 0; i < datos.reporte.length; i++){
            validador = 0;
            for(let x = 0; x < envio.length; x++){
              if(envio[x].idtbl_respuesta_conflicto == datos.reporte[i].idtbl_respuesta_conflicto){
                envio[x] = datos.reporte[i];
                validador++;
              }
            }
            if(validador == 0){
              envio.push(datos.reporte[i]);
            }            
          }
          this.bodyHojaVida = envio;
          
          for(let i = 0; i < this.bodyHojaVida.length; i++){
            this.bodyHojaVida[i].fecha_registro = moment(this.bodyHojaVida[i].fecha_registro).format('DD/MM/YYYY');
          }
          this.dataSource = new MatTableDataSource<FuncionariosElement>(this.bodyHojaVida);
          this.dataSource.paginator = this.paginator;
          this.ver_todo = true;
        }
      })
    }else{
      this.listasTerceros["usuarios"] = this.extractColumn(this.list_usuarios_all, 'nombre_completo');
    }
    this.cg.detectChanges();
  }

  clear_filter_conflictos() {
    this.conflictos_options = [];
    if(this.terceros_options.length > 0 || this.usuarios_options.length > 0){
      this.show_button_terceros = false
      let usuarios_ids = [];
      let conflictos_ids = [];
      this.usuarios_options.forEach(e => {
        let id = this.lista_funcionarios_all.find(x => x.nombre_completo === e)["idtbl_funcionario"];
        usuarios_ids.push(id)
      });
      this.conflictos_options.forEach(e => {
        let id = this.lista_preguntas_all.find(x => x.tipo_conflicto_espanol === e)["idtbl_conflicto"];
        conflictos_ids.push(id)
      });
  
      let data = {
        terceros: this.terceros_options,
        usuarios: usuarios_ids,
        conflictos: conflictos_ids
      }
      //if(this.usuarios_options.length > 0 || this.terceros_options.length > 0){
      this.serviciosService.verReporte(data).subscribe(datos => {
        if (datos["status"] && datos["status"] === 200) {
          let envio = [];
          let validador;
          for(let i = 0; i < datos.reporte.length; i++){
            validador = 0;
            for(let x = 0; x < envio.length; x++){
              if(envio[x].idtbl_respuesta_conflicto == datos.reporte[i].idtbl_respuesta_conflicto){
                envio[x] = datos.reporte[i];
                validador++;
              }
            }
            if(validador == 0){
              envio.push(datos.reporte[i]);
            }            
          }
          this.bodyHojaVida = envio;
          
          for(let i = 0; i < this.bodyHojaVida.length; i++){
            this.bodyHojaVida[i].fecha_registro = moment(this.bodyHojaVida[i].fecha_registro).format('DD/MM/YYYY');
          }
          this.dataSource = new MatTableDataSource<FuncionariosElement>(this.bodyHojaVida);
          this.dataSource.paginator = this.paginator;
          this.ver_todo = true;
        }
      })
    }else{
      this.listasTerceros["conflictos"] = this.extractColumn(this.list_conflictos_all, 'tipo_conflicto_espanol');
    }
    this.cg.detectChanges();
  }

  generar_reporte_respuestas(data){
    this.loading=true;
      
    this.serviciosService.generarReporteRespuestas(data).subscribe(datos => {
      this.respuestasCorrectas=[]
      this.respuestasIncorrectas=[]

      this.dataSourceRespuesta = new MatTableDataSource([]);
      this.dataSource2 = new MatTableDataSource([]);
     
      if (datos["status"] && datos["status"] === 200) {
        let lista_respuestas_funcionario = datos["reporte"]["respuestasFuncionario"];
        if(lista_respuestas_funcionario.length > 0){
          let pie_data_respuestas = datos["reporte"]["respuestas"][0];
          this.infoConflicto=datos["reporte"]["infoConflicto"][0]
          //console.log(this.infoConflicto)
          
          
          if(lista_respuestas_funcionario){
            this.respuestasCorrectas=lista_respuestas_funcionario.filter(item=>item.respuesta=="CORRECTO")
            this.respuestasIncorrectas=lista_respuestas_funcionario.filter(item=>item.respuesta=="INCORRECTO")
          }

        

          for(let item of this.respuestasCorrectas){
            item.fecha_registro=moment(item.fecha_registro).format('DD/MM/YYYY')
          }

          for(let item of this.respuestasIncorrectas){
            item.fecha_registro=moment(item.fecha_registro).format('DD/MM/YYYY')
          }
         
         
          this.dataSourceRespuesta = new MatTableDataSource(this.respuestasCorrectas);
          this.dataSource2 = new MatTableDataSource(this.respuestasIncorrectas);
         
          this.dataSourceRespuesta.paginator = this.paginatorRespuesta;
  
          this.dataSource2.paginator = this.paginator2;
         
  
          let arreglopie=[]
          if(this.respuestasCorrectas!=null && this.respuestasIncorrectas!=null){
            arreglopie=[this.respuestasCorrectas.length, this.respuestasIncorrectas.length]
          }
          else{
            arreglopie=[0, 0]
          }
         
          this.pieChartRespuestas = {
            series: arreglopie,
            chart: {
              width: 480,
              type: "pie"
            },
            labels: ["Respuestas Correctas", "Respuestas Incorrectas"],
            colors: ['#001871', '#8FA73B'],
            responsive: [
              {
                breakpoint: 480,
                options: {
                  chart: {
                    width: 200
                  },
                  legend: {
                    position: "bottom"
                  }
                }
              }
            ]
          };
          this.ver_respuesta = true
        }else{
          this.ver_respuesta = false
        }

        this.loading=false;
      }
      })
  }
  generar_reporte_conflictos (data) {
    this.serviciosService.generarReporteconflictos(data).subscribe(datos => {
      this.tarjeta1Conflictos=0;
      this.tarjeta2Conflictos=0;
      this.tarjeta3Conflictos=0;
      this.tarjeta4Conflictos=0;
      this.tarjeta5Conflictos=0;
      if(datos["status"] && datos["status"] === 200) {
        let reportados = datos["reporte"]["reportados"];
        let nuevos = datos["reporte"]["nuevos"].length;
        let permanecen_igual = datos["reporte"]["permanecen_igual"];
        let marcaron_cambios = datos["reporte"]["marcaron_cambios"];
        let no_existen = datos["reporte"]["report_noexisten"];
        
        this.cantidad_nuevos = nuevos;

        let array_anios = [];
        let array_permanecen_igual = [];
        let array_marcaron_cambios = [];
        let array_no_existen = [];

        if(permanecen_igual.length > 0){
          permanecen_igual.forEach(e => {
              array_anios.push(e.annio)
              array_permanecen_igual.push(e.cantidad)
          });
        }
        if(marcaron_cambios.length > 0){
          marcaron_cambios.forEach(e => {
              array_marcaron_cambios.push(e.cantidad)
          });
        }
        if(no_existen.length > 0){
          no_existen.forEach(e => {
              array_no_existen.push(e.cantidad)
          });
        }

        let permaneceAnnioActual = 0
        permanecen_igual.forEach(p => {
          permaneceAnnioActual += p.cantidad
        });

        let cambiosAnnioActual = 0
        marcaron_cambios.forEach(p => {
          cambiosAnnioActual += p.cantidad
        });

        
        let noExisteAnnioActual=no_existen.filter(item=>item.annio==this.usuario.annio)
  
        let total_reportados = 0
        reportados.forEach(r => {
          if(r['estado_conflicto']!="Cerrado"){
           
            total_reportados += r.cantidad
        }
        });
       

        this.tarjeta1Conflictos=total_reportados;
        this.tarjeta2Conflictos=total_reportados-nuevos;
        

        if(permaneceAnnioActual){
          //this.tarjeta1Conflictos+=permaneceAnnioActual
          //this.tarjeta2Conflictos+=permaneceAnnioActual
          this.tarjeta3Conflictos+=permaneceAnnioActual
        }

        if(cambiosAnnioActual){
         // this.tarjeta1Conflictos+=cambiosAnnioActual
          //this.tarjeta2Conflictos+=cambiosAnnioActual
          this.tarjeta4Conflictos+=cambiosAnnioActual
        }

        if(noExisteAnnioActual.length){
          //this.tarjeta1Conflictos+=noExisteAnnioActual[0]['cantidad']
          this.tarjeta5Conflictos+=noExisteAnnioActual[0]['cantidad']
        }

       // this.tarjeta1Conflictos+= this.cantidad_nuevos


        //console.log("TAJERTA 1",this.tarjeta1Conflictos)
        //console.log("TAJERTA 2",this.tarjeta2Conflictos)
        //console.log("TAJERTA 3",this.tarjeta3Conflictos)
        //console.log("TAJERTA 4",this.tarjeta4Conflictos)
        //console.log("TAJERTA 5",this.tarjeta5Conflictos)

        this.chartOptionsBarConflictos = {
          series: [
            {
              name: "Permanecen Igual",
              data: array_permanecen_igual,
              color: '#001871'
            },
            {
              name: "Permanecen con Cambios",
              data: array_marcaron_cambios,
              color: '#8FA73B'
            },
            {
              name: "No existen",
              data: array_no_existen,
              color: '#97999B'
            },
          ],
          chart: {
            type: "bar",
            height: 350,
            width:750
          },
          plotOptions: {
            bar: {
              horizontal: false,
              columnWidth: "55%",
              //endingShape: "rounded",
              dataLabels: {
                position: "top" // top, center, bottom
              }
            }
          },
          dataLabels: {
            enabled: true,
            formatter: function(val) {
              return val + "";
            },
            offsetY: -20,
            style: {
              fontSize: "12px",
              colors: ["#304758"]
            }
          },
          stroke: {
            show: true,
            width: 2,
            colors: ["transparent"]
          },
          xaxis: {
            categories: array_anios
          },
          yaxis: {
            title: {
              text: "Cantidad"
            }
          },
          fill: {
            opacity: 1,
            colors: ['#001871', '#8FA73B', '#97999B']
          },
          tooltip: {
            y: {
              formatter: function(val) {
                return val + " ";
              }
            }
          }
        };



        let arreglovs=[this.cantidad_nuevos,this.cantidad_reportados-this.cantidad_nuevos]
        this.pieChartNuevosPasados = {
          series: arreglovs,
          chart: {
            width: 480,
            type: "pie"
          },
          labels: ["Conflictos Nuevos", "Conflictos de años Anteriores"],
          colors: ['#001871', '#8FA73B'],
          responsive: [
            {
              breakpoint: 480,
              options: {
                chart: {
                  width: 200
                },
                legend: {
                  position: "bottom"
                }
              }
            }
          ]
        };

        this.loading = false
      }
    })
  }


  validarRespuesta(texto){
    if(texto==this.infoConflicto.texto_es){
      return true
    }
    else{
      return false
    }
  }
}
